const getters = {
    getRoles(state){
        return state.roleList;
    },
    getRole(state){
        return state.role;
    }
}

export default getters;